import {
  OperationSummary,
  WorkOrderConfig,
  WorkOrderStatus,
} from '@/components/work-orders/types';

export type SalesOrderOutcome = 'Active' | 'Completed';

export type SalesOrderStatus = 'Open' | 'Ready' | 'Completed';

export function deriveSalesOrderStatus(
  outcome: SalesOrderOutcome,
  allComplete: boolean
): SalesOrderStatus {
  if (outcome === 'Completed') return 'Completed';
  return allComplete ? 'Ready' : 'Open';
}

/** Slim WO record embedded on each Sales Order row for the detail popup. */
export interface SalesOrderWorkOrder {
  id: string;
  workOrderId: string;
  displayName: string;
  status: WorkOrderStatus;
  woStatusText: string;
  isBuilt: boolean;
  isTKS0026: boolean;
  kittingComplete: boolean;
  fabricComplete: boolean;
  metalComplete: boolean;
  finalAssemblyComplete: boolean;
  opsTotal: number;
  opsComplete: number;
  opsPercent: number;
  config: WorkOrderConfig;
}

export interface SalesOrderRow {
  id: string;
  orderNumber: string;
  customer: string;
  location: string;
  date: string;
  dateTs: number;
  workOrdersTotal: number;
  workOrdersComplete: number;
  workOrdersPercent: number;
  opsTotal: number;
  opsComplete: number;
  opsPercent: number;
  operations: OperationSummary[];
  workOrders: SalesOrderWorkOrder[];
  allComplete: boolean;
  outcome: SalesOrderOutcome;
  status: SalesOrderStatus;
  completedAt: string;
  completedTs: number;
}
